var _defs, _g, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 333.057,
    height: 300.019,
    viewBox: "0 0 333.057 300.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 114.327,
    width: 185.691,
    height: 185.691,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 34.254,
    y: 1.216,
    width: 298.803,
    height: 298.803,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    transform: "translate(0 -.004)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 63",
    cx: 62.846,
    cy: 62.846,
    transform: "translate(30 134.33)",
    fill: "#39beec",
    r: 62.846
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)",
    transform: "translate(0 -.004)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 64",
    cx: 119.401,
    cy: 119.401,
    transform: "translate(64.25 21.22)",
    fill: "#1b60a3",
    r: 119.401
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1287",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 961",
    d: "m131.101 105.792 17.67-15.1c39.343-33.682 48.893-70.68 51.18-84.633a5.234 5.234 0 0 0-3.088-5.661 4.817 4.817 0 0 0-2-.4c-14.239-.057-52.553 3.26-92.01 37L85.187 52.096l-4.98-1.373a30.174 30.174 0 0 0-27.506 6.119L31.6 74.801a4.5 4.5 0 0 0-1.487 4.346 4.33 4.33 0 0 0 3.145 3.317l16.129 4.571a23.729 23.729 0 0 1 11.608 7.434l6.633 7.777-10.179 8.749a4.45 4.45 0 0 0-.515 6.29l5.318 6.233a4.45 4.45 0 0 0 6.29.515l10.236-8.749 6.633 7.777a23.927 23.927 0 0 1 5.547 12.64l2 16.583a4.3 4.3 0 0 0 2.8 3.6 4.485 4.485 0 0 0 4.518-.8l21.044-18.013a30 30 0 0 0 10.293-26.19Zm6.062-49.064a15.408 15.408 0 1 1 18.756 1.43 15.573 15.573 0 0 1-18.756-1.431Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/Launch.8b385f3caa7d658eb43045ba7e99bba8.svg";
export { ForwardRef as ReactComponent };